import { formatChartValue } from '../../AnalyticsReport/hooks/utils/formatChartValue';
import { createAnalyticsCardHeader } from './createAnalyticsCardHeader';
export const createAnalyticsCardBaseProps = ({ isReportDataLoading, isReportDefinitionLoading, reportLink, legend, externalSource, emptyMessage, reportDefinition, activeColumn, }) => ({
    isDataLoading: isReportDataLoading,
    isDefinitionLoading: isReportDefinitionLoading,
    reportLink,
    legend,
    externalSource,
    emptyMessage,
    header: createAnalyticsCardHeader(reportDefinition, activeColumn),
    formatValue: (value) => formatChartValue(value, activeColumn?.type),
});
